import axios from 'axios';
import Topbar from '../Topbar';
import Select from 'react-select';
import 'react-tooltip/dist/react-tooltip.css';
import { surveyApi } from '../../../api/surveyApi';
import React, { useEffect, useRef, useState } from 'react';
import { CompanyApi } from '../../../api/companyApi';
import Dots from '../../../assets/images/Dots.svg';
import ActiveDots from '../../../assets/images/active-dots.svg';
import {
  capitalizeFirstLetter,
  capitalizeWords,
  errorToast,
  getPathForSurvey,
  isCopanySuperOrSubAdmin,
  isSuperAndSubAdmin,
  successToast,
  useOutsideClick,
  getLocalStorageItem
} from '../../../utils/helper';
import {
  EditSurveyShareDataValidation,
  PublishSurveyValidation
} from '../../../validation/AddEditSurveyValidation';
import SurveySuccessModal from '../../../component/common/modals/SurveySuccessModal';
import SurveyApprovalModal from '../../../component/common/modals/SurveyApprovalModal';
import BulkAnswerModal from './BulkAnswerModal';
import InsightsB2B from './InsightsB2B';
import InsightsSuper from './InsightsShoorahSuperAdmin';
import SurveyShare from './SurveyShare';
import AssessmentResultQuestion from '../../self-assessment/AssessmentResultQuestion';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Loader from '../../../component/common/Loader';
import moment from 'moment';
import { DEPARTMENT } from '../../../utils/constants';
import { pulseSurveyPageData } from '../../../utils/pageContent';

const AddEditPulseSurvey = () => {
  const maxLength = 250; //Maximum character for description
  const dropdownRef = useRef(null);
  const surveyType = localStorage.getItem('surveyType'); // Survey or Template set from index.js according to popup selection
  const navigate = useNavigate();
  // Extract the survey ID from the URL parameters
  const location = new URLSearchParams(window.location.search);
  const paramssurveyId = location.get('id');
  const PrevType = location.get('page');
  const SurType = location.get('type');

  /**
   * Retrieves the user type from the local storage.
   * Assumes that the user data is stored in the local storage under the key 'userData'.
   * Parses the user data JSON string and extracts the userType property.
   *
   * @constant {string} userType - The type of the user retrieved from the local storage.
   */
  const { userType } = JSON.parse(localStorage.getItem('userData'));

  const [surveyLogo, setSurveyLogo] = useState(''); // This is the file object for logo of survey
  const [loader, setLoader] = useState(paramssurveyId ? true : false);

  const [previewSurveyLogo, setPreviewSurveyLogo] = useState(''); // This is the preview URL for logo of survey

  /**
   * State hook to manage the survey categories.
   *
   * @type {Array}
   * @default []
   */
  const [surveyCategories, setSurveyCategories] = useState([]);

  //State for Survey Data for title description and category
  /**
   * useState hook to manage the state of survey data.
   *
   * @constant
   * @type {Array}
   * @default
   * @property {Object} 0 - The current state of the survey data.
   * @property {Function} 1 - Function to update the survey data state.
   *
   * @property {string} 0.title - The title of the survey.
   * @property {string} 0.description - The description of the survey.
   * @property {number} 0.type - The type of the survey.
   *                              2 if surveyType is 'Survey',
   *                              1 if surveyType is 'Template',
   *                              0 otherwise.
   * @property {string} 0.category - The category of the survey.
   */
  const [surveyData, setSurveyData] = useState({
    title: '',
    description: '',
    type: surveyType === 'Survey' ? 2 : surveyType === 'Template' ? 1 : 0,
    category: '',
    status: null
  });

  /**
   * State hook for managing survey question data.
   *
   * @typedef {Object} SurveyQuestionData
   * @property {string} questionTitle - The title of the survey question.
   * @property {string} qType - The type of the survey question.
   * @property {boolean} skipable - Indicates if the question can be skipped.
   * @property {boolean} hasOther - Indicates if the question has an "Other" option.
   * @property {boolean} nonAbove - Indicates if the question has a "None of the above" option.
   * @property {string} image - The image associated with the survey question.
   *
   * @type {[SurveyQuestionData, Function]} surveyQuestionData - The state and setter function for survey question data.
   */
  const [surveyQuestionData, setSurveyQuestionData] = useState({
    questionTitle: '',
    qType: '',
    skipable: false,
    hasOther: false,
    nonAbove: false,
    image: ''
  });

  // State hook to manage the visibility of the question type dropdown.
  const [isOpenQuestionType, setIsOpenQuestionType] = useState(false);

  // State hook to manage the list of survey questions.
  const [surveyQuestions, setSurveyQuestions] = useState([]);

  // State hook to manage the answer choices for survey questions.
  const [answerChoices, setAnswerChoices] = useState([{ value: '' }]);

  // State hook to manage the count of survey questions.
  const [surveyQuestionCount, setSurveyQuestionCount] = useState(1);

  /**
   * State hook for managing bulk answers in the survey.
   * split by new line
   * @type {Array}
   * @default []
   */
  const [bulkAnswers, setBulkAnswers] = useState([]);

  /**
   * State hook for managing the input value of bulk answers.
   * Raw Data
   * @type {string}
   * @default ''
   */
  const [bulkAnswerInput, setBulkAnswerInput] = useState('');

  //state for errors
  const [errors, setErrors] = useState({});

  //State for draft or publish
  const [isDraft, setIsDraft] = useState(2);

  //State for show page edit or preview
  const [showPage, setShowPage] = useState('edit');

  const [surveyShareData, setSurveyShareData] = useState({
    endHeading: '',
    endBody: '',
    audience: [],
    shareSurveyCategory: '',
    approvalBy: ''
  });

  //For approval dialog Admin list
  const [superAdminList, setSuperAdminList] = useState([]);

  //For survey approval dialog
  const [isShowSurveyApprovalModal, setIsShowSurveyApprovalModal] = useState(false);

  //state for showing bluk answer modal
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);

  //State for open/close share tab team drop down
  const [isOpenShareSurveyTeamMenu, setIsOpenShareSurveyTeamMenu] = useState(false);

  //state for cover image
  const [coverImg, setCoverImgUrl] = useState('');
  const [surveyCoverImage, setSurveyCoverImage] = useState('');

  //state foe managing calendanr show and hide
  const [showCalendar, setShowCalendar] = useState(false);

  //state for publish date for share tab
  const [publishDate, setPublishDate] = useState('');

  // related to date picker
  const [isOpen, setIsOpen] = useState(false);

  //State related to time picker
  const [isOpenT, setIsOpenT] = useState(false);
  const [selectedTime, setSelectedTime] = useState('');

  const [addUserPopUpOpenSurvey, setAddUserPopUpOpenSurvey] = useState(false);

  const shareSurveyTeamOptions = DEPARTMENT?.slice(1);
  // const shareSurveyTeamOptions = ['IT', 'Marketing', 'Customer Service'];

  const [emailInput, setEmailInput] = useState('');

  const [emails, setEmails] = useState([]);

  const [text, setText] = useState('');
  const surveyId = localStorage.getItem('pulseSurveyId');

  const [dropDownIndex, setDropDownIndex] = useState();
  const [surveyQuestionImage, setSurveyQuestionImage] = useState({});
  const [surveyQuestionImagePreview, setSurveyQuestionImagePreview] = useState({});
  const [tempImagePreview, setTempImagePreview] = useState('');
  const [surveyQuestionImageIndex, setSurveyQuestionImageIndex] = useState(1);
  const [isShowSurveySuccessModal, setIsShowSurveySuccessModal] = useState(false);
  const [surveyQuestionResultList, setSurveyQuestionResultList] = useState([]);
  const [surveyStatus, setSurveyStatus] = useState('');
  const pageData = pulseSurveyPageData.addSurveyPageData;

  // const location = useLocation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const templateId = searchParams.get('templateId');
  const title = id ? pageData.editSurveyTitle : pageData.createSurveyTitle;
  const contentApproval = searchParams.get('contentApproval');

  let isAdmin;
  isAdmin =
    userType === 0 || userType === 1 ? true : userType === 3 || userType === 4 ? false : true;

  useEffect(() => {
    if (paramssurveyId) {
      if (surveyStatus === 5) {
        if (PrevType === 'view') {
          setShowPage('preview');
        } else if (PrevType === 'edit') {
          setShowPage('edit');
        } else if (PrevType === 'share') {
          setShowPage('share');
        } else if (PrevType === 'results') {
          setShowPage('results');
        } else if (PrevType === 'insights') {
          setShowPage('insights');
          console.log('🚀 ~ insights SHIFT');
        } else {
          setShowPage('preview');
        }
      } else {
        if (PrevType === 'view') {
          setShowPage('preview');
        } else if (PrevType === 'edit') {
          setShowPage('edit');
        } else if (PrevType === 'share') {
          setShowPage('share');
        } else {
          setShowPage('edit');
        }
      }
    }
  }, [PrevType, surveyStatus, paramssurveyId]);

  useEffect(() => {
    if (templateId) {
      setLoader(true);
      surveyApi
        .getByTemplateByAdmin(templateId, isAdmin)
        .then((response) => {
          setLoader(false);
          setSurveyStatus(response?.data?.data?.status);
          setPreviewSurveyLogo(response?.data?.data?.logo);
          setCoverImgUrl(response?.data?.data?.coverImage);
          setSurveyShareData({
            endHeading: response?.data?.data?.endHeading,
            endBody: response?.data?.data?.endBody,
            audience: response?.data?.data?.audience || [],
            shareSurveyCategory: response?.data?.data?.category
            // approvalBy: response?.data?.data?.approvalBy
          });
          const transformedData = response?.data?.data?.questions.map((question) => ({
            questionTitle: question.title,
            qType: question.type,
            skipable: question.skipable,
            hasOther: question.hasOther,
            nonAbove: false,
            options: question?.options?.map((option) => ({
              value: option?.value
            })),
            image: question.image
          }));

          setSurveyQuestions(transformedData);
          setSurveyData({
            title: response?.data?.data?.title,
            description: response?.data?.data?.description,
            type: 2,
            category: response?.data?.data?.category,
            status: response?.data?.data?.status
          });
        })
        .catch((error) => {
          setLoader(false);
        });
    }
  }, [templateId]);

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setEmailInput(value);
  };

  useEffect(() => {
    if (paramssurveyId) {
      surveyApi
        .getByIdByAdmin(paramssurveyId, isAdmin)
        .then((response) => {
          localStorage.setItem(
            'surveyType',
            response?.data?.data?.type === 2 || response?.data?.data?.type === 0
              ? 'Survey'
              : 'Template'
          );
          setLoader(false);
          setSurveyStatus(response?.data?.data?.status);
          setPreviewSurveyLogo(response?.data?.data?.logo);
          setCoverImgUrl(response?.data?.data?.coverImage);
          setEmailInput(response?.data?.data?.email?.join(', '));
          response?.data?.data?.publishDateTime &&
            setSelectedTime(moment(response?.data?.data?.publishDateTime).format('h:mm a'));
          response?.data?.data?.publishDateTime &&
            setPublishDate(moment(response?.data?.data?.publishDateTime).format('YYYY-MM-DD'));
          setSurveyShareData({
            endHeading: response?.data?.data?.endHeading,
            endBody: response?.data?.data?.endBody,
            audience: response?.data?.data?.audience || response?.data?.data?.department,
            shareSurveyCategory: response?.data?.data?.category
            // approvalBy: response?.data?.data?.approvalBy
          });
          const transformedData = response?.data?.data?.questions?.map((question) => ({
            questionTitle: question.title,
            qType: question.type,
            skipable: question.skipable,
            hasOther: question.hasOther,
            nonAbove: false,
            options: question?.options?.map((option) => ({
              value: option?.value
            })),
            image: question.image
          }));

          setSurveyQuestions(transformedData || []);
          setSurveyData({
            title: response?.data?.data?.title,
            description: response?.data?.data?.description,
            type: response?.data?.data?.type,
            status: response?.data?.data?.status,
            category: response?.data?.data?.category
          });
          if (response?.data?.meta?.code === 200) {
            // setLoader(false);
            // successToast(response?.data?.meta?.message);
          } else if (response?.data?.meta?.code === 0) {
            // setLoader(false);
            errorToast(response?.data?.meta?.message);
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
        });
    }
    localStorage.setItem('pulseSurveyId', paramssurveyId);
  }, []);

  const toggleDropdown = (index) => {
    setIsOpen(!isOpen);
    setDropDownIndex(index);
  };

  /**
   * Handles the upload of the survey logo.
   *
   * This function is triggered when a file is selected for the survey logo.
   * It sets the selected file as the survey logo and creates a preview URL for the logo.
   *
   * @param {Event} e - The event object from the file input change event.
   */

  const handleUploadSurveyLogo = (e) => {
    const file = e.target.files[0];
    if (!file?.name?.match(/\.(jpg|jpeg|png)$/i)) {
      errorToast(pageData.imageFormatNotSupportedMessage);
    } else {
      if (file) {
        setSurveyLogo(file);
        setPreviewSurveyLogo(URL.createObjectURL(file));
      }
    }
  };

  /**
   * Handles the change event for survey data input fields.
   *
   * @param {Event} e - The event object from the input field.
   */
  const handleGetSurveyData = (e) => {
    let processedValue = e.target.value;

    // Auto-capitalize based on field type
    if (e.target.name === 'title') {
      processedValue = capitalizeWords(e.target.value);
    } else if (e.target.name === 'description') {
      processedValue = capitalizeFirstLetter(e.target.value);
    }

    setSurveyData({ ...surveyData, [e.target.name]: processedValue });
  };

  /**
   * Fetches survey category data based on user type.
   * If userType is 0 or 1, it fetches survey categories for admin.
   * Otherwise, it fetches survey categories for the company.
   */
  const handleGetSurveyCategoryData = async () => {
    userType === 0 || userType === 1
      ? surveyApi.getSurveyCategory().then((response) => {
          if (response?.data?.meta?.code === 200) {
            setSurveyCategories(response?.data?.data);
          }
        })
      : CompanyApi.getSurveyCategoryCompany().then((response) => {
          if (response?.data?.meta?.code === 200) {
            setSurveyCategories(response?.data?.data);
          }
        });
  };

  /**
   * Transforms survey category data into options for a dropdown.
   * Each option contains a value (category ID) and a label (category name).
   */
  const surveyCategory = surveyCategories.map((surveyCategory) => {
    return {
      value: surveyCategory?._id,
      label: surveyCategory?.name?.charAt(0)?.toUpperCase() + surveyCategory?.name?.slice(1)
    };
  });

  /**
   * Handles the selection of a survey category.
   *
   * @param {Object} e - The event object.
   * @param {string} e.value - The selected category value.
   */
  const handleGetSurveyCategory = (e) => {
    setSurveyData({ ...surveyData, category: e.value });
    setSurveyShareData({ ...surveyShareData, shareSurveyCategory: e.value });
  };

  /**
   * Handles the change event for survey question data input fields.
   *
   * @param {Event} e - The event object from the input field change event.
   */
  const handleGetQuestionData = (e) => {
    setSurveyQuestionData({ ...surveyQuestionData, [e.target.name]: e.target.value });
  };

  // Handle upload question images
  const handleUploadQuestionImage = (e) => {
    const file = e.target.files[0];
    if (!file?.name?.match(/\.(jpg|jpeg|png)$/i)) {
      errorToast(pageData.imageFormatNotSupportedMessage);
    } else {
      if (file) {
        setSurveyQuestionData((prev) => ({
          ...prev,
          image: file
        }));
      }
    }
  };

  /**
   * Handles the saving of a survey question.
   *
   * Validates the survey question data and displays error toasts if validation fails.
   * If validation passes, it creates a new question object and adds it to the survey questions list.
   * Displays a success toast upon successful addition of the question.
   * Resets the temporary image preview, survey question image index, and form fields.
   *
   * @function handleSaveSurveyQuestion
   * @returns {void}
   */
  const handleSaveSurveyQuestion = () => {
    // if (editQuestionIndex === null) {
    if (!surveyQuestionData?.questionTitle?.trim()) {
      errorToast(pageData.pleaseAddQuestionErrorMessage);
      return;
    }
    if (!surveyQuestionData?.qType) {
      errorToast(pageData.selectQuestionTypeErrorMessage);
      return;
    }
    if (
      surveyQuestionData.qType !== 3 &&
      answerChoices.length === 1 &&
      !answerChoices[0].value.trim()
    ) {
      errorToast(pageData.addAtLeastOneValidAnswerErrorMessage);
      return;
    }

    const newObj = {
      ...surveyQuestionData,
      options: answerChoices
    };
    setSurveyQuestions([...surveyQuestions, newObj]);
    successToast(pageData.questionAddedSuccessMessage);
    setTempImagePreview('');
    setSurveyQuestionImageIndex(surveyQuestionImageIndex + 1);

    setErrors('');
    setSurveyQuestionData({
      questionTitle: '',
      hasOther: false,
      skipable: false,
      nonAbove: false,
      image: ''
    });
    setTempImagePreview('');
    setAnswerChoices([{ value: '' }]);
  };

  // Handle get data from answer choice field
  /**
   * Updates the value of an answer choice at a specific index.
   *
   * @param {number} index - The index of the answer choice to update.
   * @param {Object} e - The event object containing the new value.
   * @param {Object} e.target - The target element of the event.
   * @param {string} e.target.value - The new value to set for the answer choice.
   */

  const handleGetQueAns = (index, e) => {
    setAnswerChoices((prev) => {
      const newAnswerChoices = [...prev];
      newAnswerChoices[index] = { ...newAnswerChoices[index], value: e.target.value };
      return newAnswerChoices;
    });
  };

  /**
   * Removes an answer field from the answer choices.
   *
   * @param {number} index - The index of the answer field to remove.
   * @throws Will display an error toast if attempting to remove the last answer field.
   */
  const removeAnswerField = (index) => {
    if (answerChoices.length === 1) {
      errorToast(pageData.lastAnswerremoveErrorMessage);
      return; // Prevent removal
    }
    const newAnswerChoices = answerChoices.filter((_, i) => i !== index);
    setAnswerChoices(newAnswerChoices);
    setSurveyQuestionCount(surveyQuestionCount - 1);
  };

  /**
   * Adds a new answer field to the survey.
   * This function updates the state by adding a new answer choice with an empty value
   * and increments the survey question count by one.
   */
  const addAnswerField = () => {
    setAnswerChoices([...answerChoices, { value: '' }]);
    setSurveyQuestionCount(surveyQuestionCount + 1);
  };

  /**
   * Handles the input event for bulk answer data.
   *
   * This function updates the bulk answer input state with the value from the event target,
   * splits the input value by new lines to create an array of answers, and updates the bulk answers state.
   *
   * @param {Event} event - The input event triggered by the user.
   */
  const handleGetBulkAnswerData = (event) => {
    setBulkAnswerInput(event.target.value);
    const answersArray = event.target.value.split('\n');
    setBulkAnswers(answersArray);
  };

  /**
   * Handles saving bulk answers based on the provided type.
   *
   * @param {string} type - The type of action to perform. If 'save', the bulk answers are saved.
   *                        Otherwise, the input is reset and a default answer choice is set.
   */
  const handleSaveBulkAnswer = (type) => {
    if (type === 'save') {
      const bulkAnswer = bulkAnswers
        .map((answer) => ({ value: answer.trim() })) // Ensure no trailing spaces
        .filter((answer) => answer.value !== ''); // Filter out empty answers

      if (bulkAnswer.length > 0) {
        setAnswerChoices((prevAnswerChoices) => {
          // Filter existing choices to remove blanks and avoid duplicates
          if (!prevAnswerChoices || prevAnswerChoices.length === 0) return [...bulkAnswer];
          const existingChoices = prevAnswerChoices.filter(
            (choice) =>
              choice.value.trim() !== '' && !bulkAnswer.some((ba) => ba.value === choice.value)
          );
          return [...existingChoices, ...bulkAnswer];
        });
      }

      // Close modal and reset input
      setIsBulkModalOpen(false);
      setBulkAnswerInput('');
      setErrors('');
    } else {
      // Cancel operation
      setBulkAnswerInput('');
      setIsBulkModalOpen(false);
      setErrors('');
      setAnswerChoices([{ value: '' }]); // Optional: Reset choices on cancel
    }
  };

  /**
   * Handles the preview of the survey based on the provided type.
   * If the type is 'preview', it validates the survey data before proceeding.
   * If the validation fails, it sets the errors and stops further execution.
   * If the validation passes or the type is not 'preview', it sets the page to show accordingly.
   *
   * @param {string} type - The type of action to perform, e.g., 'preview'.
   */
  const handlePreviewSurvey = (type) => {
    if (type === 'preview') {
      const sendDataObj = {
        title: surveyData.title,
        description: surveyData.description,
        category: surveyData.category,
        questions: surveyQuestions
      };

      const { errors, isValid } = PublishSurveyValidation(sendDataObj);
      if (!isValid) {
        setErrors(errors);
        return;
      } else {
        setErrors({});
        setShowPage(type);
      }
    } else {
      setShowPage(type);
    }
  };

  /**
   * Handles the submission of a survey. This function prepares the survey data,
   * including title, description, type, category, logo, and questions, and sends
   * it to the appropriate API endpoint for either creating a new survey or editing
   * an existing one. If the survey contains images, it uploads them to the specified
   * URLs provided by the API response.
   *
   * @function handleSubmitSurvey
   * @returns {void}
   */
  const handleSubmitSurvey = () => {
    setLoader(true);
    console.log('surveyData', paramssurveyId);
    // In handleSubmitSurvey function
    let status;

    // Determine status based on content type and user type
    if (surveyType === 'Template') {
      if (userType === 0) {
        // Shoorah Super Admin - templates are published directly
        status = 5; // PUBLISHED
      } else if (userType === 1) {
        // Shoorah Sub Admin - templates need approval
        status = 2; // SENT_APPROVAL
      }
    } else {
      console.log(userType);
      // For Surveys
      if (userType === 0 || userType === 3) {
        // Shoorah Super Admin or B2B Super Admin
        status = 0; // INACTIVE
      } else if (userType === 1 || userType === 4) {
        // Shoorah Sub Admin or B2B Sub Admin
        status = 6; // DRAFT
      }
    }
    console.log('status', status);
    let surveyFileObect = {};
    const sendDataObj = {
      title: surveyData.title?.trim(),
      ...(templateId && { template_id: templateId }),
      description: surveyData.description?.trim(),
      status: surveyType === 'Survey' && !paramssurveyId ? 6 : 5,
      ...(isAdmin && { type: surveyType === 'Survey' ? 2 : 1 }),
      category: surveyData.category,
      ...(surveyLogo && { logo: surveyLogo.type }),

      questions: surveyQuestions?.map((surveyQuestion, index) => {
        if (surveyQuestion.image?.type) {
          surveyFileObect = { ...surveyFileObect, [`ques${index + 1}Image`]: surveyQuestion.image };
        }
        return {
          title: surveyQuestion?.questionTitle?.trim(),
          qType: surveyQuestion?.qType,
          options: surveyQuestion?.options
            ?.filter((o) => o.value !== '')
            ?.map((o) => o?.value?.trim()),
          hasOther: surveyQuestion?.hasOther,
          skipable: surveyQuestion?.skipable,
          image: surveyQuestion?.image?.type ? surveyQuestion?.image?.type : surveyQuestion?.image
        };
      })
    };

    if (paramssurveyId) {
      sendDataObj.id = paramssurveyId;
      // sendDataObj.status = surveyData?.status === 6 ? 6 : userType === 1 || userType === 4 ? 6 : 5;

      surveyApi
        .editSurveyByAdmin(sendDataObj, isAdmin)
        .then(async (response) => {
          if (response?.data?.meta?.code === 200) {
            const meta = response.data.meta;
            const uploadPromises = [];
            !meta?.logo && !meta?.logo?.uploadURL && setLoader(false);
            !meta?.logo &&
              !meta?.logo?.uploadURL &&
              successToast(pageData.surveyUpdatedSuccessMessage);
            if (meta?.logo && meta?.logo?.uploadURL) {
              uploadPromises.push(
                uploadImage(surveyLogo, meta?.logo?.uploadURL, meta?.logo?.filename)
              );
            }

            for (const key in response?.data?.meta) {
              if (key.startsWith('ques') && key.endsWith('Image')) {
                const uploadPromise = uploadImage(
                  surveyFileObect[key],
                  response?.data?.meta[key]?.uploadURL,
                  response?.data?.meta[key]?.filename
                );
                uploadPromises.push(uploadPromise);
              }
            }

            if (uploadPromises.length > 0) {
              try {
                const results = await Promise.all(uploadPromises);

                if (results.every((result) => result.status === 200)) {
                  setLoader(false);
                  successToast(pageData.surveyUpdatedSuccessMessage);
                  surveyFileObect = {};
                  surveyType === 'Survey'
                    ? setShowPage('share')
                    : setIsShowSurveySuccessModal(true);
                } else {
                  setLoader(false);
                  console.error('Some images failed to upload:', results);
                }
              } catch (error) {
                setLoader(false);
                console.error('Error during uploads:', error);
                errorToast(error);
              } finally {
                setLoader(false);
              }
            } else {
              setLoader(false);
              surveyType === 'Survey' ? setShowPage('share') : setIsShowSurveySuccessModal(true);
            }
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
        })
        .finally(() => {
          setLoader(false);
        });
    } else {
      surveyApi
        .createSurveyByAdmin(sendDataObj, isAdmin)
        .then(async (response) => {
          if (response?.data?.meta?.code === 200) {
            localStorage.setItem('pulseSurveyId', response?.data?.data?.id);
            const meta = response.data.meta;
            const uploadPromises = [];

            if (meta?.logo && meta?.logo?.uploadURL) {
              uploadPromises.push(
                uploadImage(surveyLogo, meta?.logo?.uploadURL, meta?.logo?.filename)
              );
            }

            for (const key in meta) {
              if (key.startsWith('ques') && key.endsWith('Image')) {
                const uploadPromise = uploadImage(
                  surveyFileObect[key],
                  meta[key]?.uploadURL,
                  meta[key]?.filename
                );
                uploadPromises.push(uploadPromise);
              }
            }

            uploadPromises.length === 0 &&
              !meta?.logo &&
              !meta?.logo?.uploadURL &&
              setLoader(false);
            uploadPromises.length === 0 &&
              !meta?.logo &&
              !meta?.logo?.uploadURL &&
              successToast(pageData.surveyCreateSuccessMessage);

            if (uploadPromises.length > 0) {
              try {
                const results = await Promise.all(uploadPromises);
                if (results.every((result) => result.status === 200)) {
                  setLoader(false);
                  successToast(pageData.surveyCreateSuccessMessage);
                  if (surveyType === 'Survey') {
                    setLoader(false);
                    setShowPage('share');
                  } else {
                    setLoader(false);
                    if (userType === 0) {
                      setIsShowSurveySuccessModal(true);
                    } else {
                      setIsShowSurveyApprovalModal(!isShowSurveyApprovalModal);
                      surveyApi.getAdminList(0).then(async (response) => {
                        if (response?.data?.meta?.code === 1) {
                          setSuperAdminList(response?.data?.data);
                        }
                      });
                    }
                  }
                } else {
                  setLoader(false);
                  console.error('Some images failed to upload:', results);
                }
              } catch (error) {
                setLoader(false);
                console.error('Error during uploads:', error);
                errorToast(error);
              } finally {
                setLoader(false);
              }
            } else {
              if (surveyType === 'Survey') {
                setLoader(false);
                setShowPage('share');
              } else {
                if (userType === 0) {
                  setIsShowSurveySuccessModal(true);
                  setLoader(false);
                } else {
                  setIsShowSurveyApprovalModal(!isShowSurveyApprovalModal);
                  surveyApi
                    .getAdminList(0)
                    .then(async (response) => {
                      if (response?.data?.meta?.code === 1) {
                        setLoader(false);
                        setSuperAdminList(response?.data?.data);
                      } else {
                        setLoader(false);
                      }
                    })
                    .catch((error) => {
                      setLoader(false);
                    });
                }
              }
            }
          }
        })
        .catch((error) => {
          setLoader(false);
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  const getSurveyResult = async () => {
    // setLoader(true);
    // if (isCopanySuperOrSubAdmin()) {
    const id = localStorage.getItem('pulseSurveyId');
    surveyApi
      .getSurveyResult(id, isAdmin)
      .then((response) => {
        const formatData = response?.data?.data?.questions?.map((question) => {
          console.log('question', question);
          const questionInfo = {
            questionId: question.questionId,
            title: question.questionTitle, // Renamed 'questionTitle' to 'title'
            totalResponses: question.totalResponses
          };
          if (question?.optionCounts?.length > 0) {
            questionInfo.options = question?.optionCounts?.map((option) => {
              return {
                optionId: option.optionId,
                value: option.optionValue, // Renamed 'optionValue' to 'value'
                count: option.count,
                percentage: option.percentage
              };
            });
          }
          return questionInfo;
        });
        setSurveyQuestionResultList(formatData);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
    // }
  };

  const [insightsData, setInsightsData] = useState([]);
  const [userAgeRangeData, setUserAgeRangeData] = useState([]);

  const fetchInsightsData = () => {
    // if (isCopanySuperOrSubAdmin()) {
    const id = localStorage.getItem('pulseSurveyId');
    const companyId = JSON.parse(localStorage.getItem('userData')).companyId;
    console.log('🚀 ~ fetch Insights Data companyId:', companyId);
    surveyApi
      .getSurveyInsights(id, isSuperAndSubAdmin())
      .then((response) => {
        setLoader(false);
        setInsightsData(response?.data?.data);
        setUserAgeRangeData(response?.data?.data?.ageRangeDistribution);
      })
      .catch((error) => {
        console.log('Error at fetch insights data', error);
        setLoader(false);
      });
    // }
  };

  useEffect(() => {
    if (showPage === 'results') {
      if (surveyQuestionResultList.length === 0) {
        setLoader(true);
      }
      getSurveyResult();
    }
    if (showPage === 'insights') {
      if (insightsData.length === 0) {
        setLoader(true);
      }
      fetchInsightsData();
    }
  }, [showPage]);

  const handleToggleCalendar = () => {
    setShowCalendar((prevShowCalendar) => !prevShowCalendar);
  };

  const handleChangeC = (e) => {
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    setPublishDate(formattedDate);
    setShowCalendar(false);
  };

  const handleSelectT = (time) => {
    setSelectedTime(time);
    setIsOpenT(false);
  };

  const convertToISO = (dateTimeString) => {
    const formattedDateTimeString = dateTimeString.replace('AM', ' AM').replace('PM', ' PM');
    const date = new Date(formattedDateTimeString);
    const isoDate = date.toISOString();
    return isoDate;
  };

  const getFilePreviewUrl = (file) => {
    if (!file) {
      throw new Error(pageData.noDataFoundText);
    }

    if (!(file instanceof File)) {
      throw new Error(pageData.inputMustBeInFileObjectErrorMessage);
    }

    return URL.createObjectURL(file);
  };

  const isUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const uploadImage = async (imageFile, uploadURL, fileName) => {
    try {
      const response = await axios.put(uploadURL, imageFile, {
        headers: {
          'Content-Type': imageFile.type
        }
      });
      if (response.status === 200) {
        return response;
      } else {
        throw new Error(pageData.uploadFailedWithStatusErrorMessage + response);
      }
    } catch (error) {
      return error;
    }
  };

  const handleSaveDraft = () => {
    if (!surveyData.title) {
      setErrors({ title: pageData.titleIsRequriedMessage });
    } else {
      setLoader(true);
      setErrors({});
      let surveyFileObect = {};
      const sendDataObj = {
        title: surveyData.title,
        description: surveyData.description,
        ...(isAdmin && { type: surveyType === 'Survey' ? 2 : 1 }),
        status: 6,
        category: surveyData.category,
        ...(surveyLogo && { logo: surveyLogo.type }),
        questions: surveyQuestions?.length
          ? surveyQuestions.map((surveyQuestion, index) => {
              if (surveyQuestion.image?.type) {
                surveyFileObect = {
                  ...surveyFileObect,
                  [`ques${index + 1}Image`]: surveyQuestion.image
                };
              }
              return {
                title: surveyQuestion?.questionTitle,
                qType: surveyQuestion?.qType,
                options: surveyQuestion?.options
                  ?.filter((o) => o.value !== '')
                  ?.map((o) => o.value),
                hasOther: surveyQuestion?.hasOther,
                skipable: surveyQuestion?.skipable,
                image: surveyQuestion?.image?.type
                  ? surveyQuestion?.image?.type
                  : surveyQuestion?.image
              };
            })
          : undefined
      };

      const cleanedDataObj = JSON.parse(
        JSON.stringify(sendDataObj, (key, value) => {
          return value === undefined || value === null || value === '' ? undefined : value;
        })
      );

      if (paramssurveyId) {
        sendDataObj.id = paramssurveyId;
        surveyApi
          .editSurveyByAdmin(sendDataObj, isAdmin)
          .then(async (response) => {
            if (response?.data?.meta?.code === 200) {
              const meta = response.data.meta;
              const uploadPromises = [];
              if (meta?.logo && meta?.logo?.uploadURL) {
                uploadPromises.push(
                  uploadImage(surveyLogo, meta?.logo?.uploadURL, meta?.logo?.filename)
                );
              }

              for (const key in response?.data?.meta) {
                if (key.startsWith('ques') && key.endsWith('Image')) {
                  const uploadPromise = uploadImage(
                    surveyFileObect[key],
                    response?.data?.meta[key]?.uploadURL,
                    response?.data?.meta[key]?.filename
                  );
                  uploadPromises.push(uploadPromise);
                }
              }

              uploadPromises.length === 0 &&
                !meta?.logo &&
                !meta?.logo?.uploadURL &&
                setLoader(false);
              uploadPromises.length === 0 &&
                !meta?.logo &&
                !meta?.logo?.uploadURL &&
                successToast(response?.data?.meta?.message);
              uploadPromises.length === 0 &&
                !meta?.logo &&
                !meta?.logo?.uploadURL &&
                setIsShowSurveySuccessModal(true);

              if (uploadPromises.length > 0) {
                try {
                  const results = await Promise.all(uploadPromises);
                  if (results.every((result) => result.status === 200)) {
                    successToast(response?.data?.meta?.message);
                    surveyFileObect = {};
                    setIsDraft(0);
                    setIsShowSurveySuccessModal(true);
                  } else {
                    console.error('Some images failed to upload:', results);
                  }
                } catch (error) {
                  console.error('Error during uploads:', error);
                  errorToast(error);
                }
              } else {
                setIsDraft(0);
                setIsShowSurveySuccessModal(true);
              }
            } else {
              setLoader(false);
            }
          })
          .catch((error) => {
            setLoader(false);
          });
      } else {
        surveyApi
          .createSurveyByAdmin(sendDataObj, isAdmin)
          .then(async (response) => {
            if (response?.data?.meta?.code === 200) {
              localStorage.setItem('pulseSurveyId', response?.data?.data?.id);
              const meta = response.data.meta;
              const uploadPromises = [];

              if (meta?.logo && meta?.logo?.uploadURL) {
                uploadPromises.push(
                  uploadImage(surveyLogo, meta?.logo?.uploadURL, meta?.logo?.filename)
                );
              }

              for (const key in meta) {
                if (key.startsWith('ques') && key.endsWith('Image')) {
                  const uploadPromise = uploadImage(
                    surveyFileObect[key],
                    meta[key]?.uploadURL,
                    meta[key]?.filename
                  );
                  uploadPromises.push(uploadPromise);
                }
              }

              uploadPromises.length === 0 &&
                !meta?.logo &&
                !meta?.logo?.uploadURL &&
                setLoader(false);
              uploadPromises.length === 0 &&
                !meta?.logo &&
                !meta?.logo?.uploadURL &&
                successToast(pageData.surveyCreateSuccessMessage);
              uploadPromises.length === 0 &&
                !meta?.logo &&
                !meta?.logo?.uploadURL &&
                setIsShowSurveySuccessModal(true);

              if (uploadPromises.length > 0) {
                try {
                  const results = await Promise.all(uploadPromises);
                  if (results.every((result) => result.status === 200)) {
                    successToast(pageData.surveyCreateSuccessMessage);
                    setIsDraft(0);
                    setLoader(false);
                    setIsShowSurveySuccessModal(true);
                  } else {
                    setLoader(false);
                    console.error('Some images failed to upload:', results);
                  }
                } catch (error) {
                  setLoader(false);
                  console.error('Error during uploads:', error);
                  errorToast(error);
                }
              } else {
                setIsDraft(0);
                setLoader(false);
                setIsShowSurveySuccessModal(true);
              }
            }
          })
          .catch((error) => {
            setLoader(false);
          });
      }
    }
  };

  console.log('🚀 ~ surveyId && isCopanySuperOrSubAdmin():', surveyId, isCopanySuperOrSubAdmin());

  // Edit, Delete and Duplicate Question Actions
  const handleQuestionAction = (type, questionIndex, data) => {
    if (type === 'delete') {
      const updatedObjectImage = {};
      const updatedObjectImagePreview = {};

      for (const key in surveyQuestionImage) {
        if (key !== `ques${questionIndex + 1}Image`) {
          const match = key.match(/ques(\d+)Image/);
          if (match) {
            const index = parseInt(match[1], 10);
            updatedObjectImage[`ques${index > questionIndex + 1 ? index - 1 : index}Image`] =
              surveyQuestionImage[key];
          }
        }
      }

      for (const key in surveyQuestionImagePreview) {
        if (key !== `ques${questionIndex + 1}Image`) {
          const match = key.match(/ques(\d+)Image/);
          if (match) {
            const index = parseInt(match[1], 10);
            updatedObjectImagePreview[`ques${index > questionIndex + 1 ? index - 1 : index}Image`] =
              surveyQuestionImagePreview[key];
          }
        }
      }

      const filteredSurveyQuestionDataObj = surveyQuestions.filter(
        (i, index) => index !== questionIndex
      );
      setSurveyQuestions(filteredSurveyQuestionDataObj);
      setSurveyQuestionImage(updatedObjectImage);
      setSurveyQuestionImagePreview(updatedObjectImagePreview);
    }

    if (type === 'edit') {
      setSurveyQuestionData({
        questionTitle: data?.questionTitle,
        hasOther: data?.hasOther,
        skipable: data?.skipable,
        nonAbove: data?.nonAbove,
        qType: data?.qType,
        image: data?.image
      });
      setTempImagePreview(data?.image);
      const newSurveyQuestions = surveyQuestions.filter((item, index) => index !== questionIndex);
      setSurveyQuestions(newSurveyQuestions);
      setAnswerChoices(data?.options);
      // setTempQuestion(data?.options);
    }

    if (type === 'duplicate') {
      const duplicateQuestion = surveyQuestions[questionIndex];
      setSurveyQuestions([...surveyQuestions, duplicateQuestion]);

      const originalImageKey = questionIndex + 1;
      const newImageKey = originalImageKey + 1;
      const duplicatedImage = surveyQuestionImagePreview[`ques${originalImageKey}Image`];

      if (duplicatedImage) {
        setSurveyQuestionImage((prev) => ({
          ...prev,
          [`ques${newImageKey}Image`]: surveyQuestionImage[`ques${originalImageKey}Image`]
        }));
        setSurveyQuestionImagePreview((prev) => ({
          ...prev,
          [`ques${newImageKey}Image`]: duplicatedImage
        }));
      }
    }
  };

  const handleGetEndPageData = ({ target: { name, value } }) => {
    setSurveyShareData({ ...surveyShareData, [name]: value });
  };

  const handleSendSurvey = () => {
    console.log('🚀 ~ handleSendSurvey ~ userType:', userType);
    console.log('🚀 ~ handleSendSurvey ~ surveyId:', surveyId);
    console.log('🚀 ~ handleSendSurvey ~ surveyShareData:', surveyShareData);
    console.log('🚀 ~ handleSendSurvey ~ emailInput:', emailInput);

    if (userType === 0 || userType === 1) {
      if (userType === 0) {
        const { errors, isValid } = EditSurveyShareDataValidation({
          email: emailInput,
          audience: surveyShareData.audience,
          endHeading: surveyShareData.endHeading,
          endBody: surveyShareData.endBody
        });
        if (!isValid) {
          setErrors(errors);
        } else {
          setLoader(true);
          let sendDataObj = {
            id: localStorage.getItem('pulseSurveyId'),
            audience: surveyShareData.audience,
            ...(surveyCoverImage && { coverImage: surveyCoverImage.type }),
            ...(publishDate &&
              selectedTime && {
                publishDateTime: convertToISO(`${publishDate} ${selectedTime}`) || ''
              }),
            // publishDateTime:
            //   publishDate && selectedTime ? convertToISO(`${publishDate} ${selectedTime}`) : '',
            endHeading: surveyShareData.endHeading?.trim(),
            endBody: surveyShareData.endBody?.trim(),
            ...(surveyData.category && { category: surveyData.category })
          };
          surveyApi
            .editSurveyByAdmin(sendDataObj, isAdmin)
            .then(async (response) => {
              if (response?.data?.meta?.code === 200) {
                const meta = response.data.meta;
                setSurveyShareData({
                  audience: '',
                  endBody: '',
                  endHeading: '',
                  shareSurveyCategory: ''
                });
                setSurveyCoverImage('');
                !meta?.coverImage &&
                  !meta?.coverImage?.uploadURL &&
                  setIsShowSurveySuccessModal(true);
                !meta?.coverImage &&
                  !meta?.coverImage?.uploadURL &&
                  successToast(pageData.surveyUpdatedSuccessMessage);
                if (meta?.coverImage && meta?.coverImage?.uploadURL) {
                  const uploadImageResponse = await uploadImage(
                    surveyCoverImage,
                    meta?.coverImage?.uploadURL,
                    meta?.coverImage?.filename
                  );
                  if (uploadImageResponse?.status === 200) {
                    setIsShowSurveySuccessModal(true);
                    successToast(pageData.surveyUpdatedSuccessMessage);
                  }
                }
                localStorage.removeItem('surveyId');
                setLoader(false);
              }
            })
            .catch((error) => {
              setLoader(false);
            });
          setErrors('');
        }
      } else {
        const { errors, isValid } = EditSurveyShareDataValidation({
          email: emailInput,
          audience: surveyShareData.audience,
          endHeading: surveyShareData.endHeading,
          endBody: surveyShareData.endBody
        });
        if (!isValid) {
          setErrors(errors);
        } else {
          setLoader(true);
          setIsShowSurveyApprovalModal(!isShowSurveyApprovalModal);
          surveyApi
            .getAdminList(0)
            .then(async (response) => {
              if (response?.data?.meta?.code === 1) {
                setLoader(false);
                setSuperAdminList(response?.data?.data);
              } else {
                setLoader(false);
              }
            })
            .catch((error) => {
              setLoader(false);
            });
        }
      }
    } else {
      console.log('🚀 ~ Not Shoorah Admin, checking if Company Admin...');
      if (userType === 3 || userType === 4) {
        console.log('🚀 ~ Company Admin Flow (userType 3 or 4)');
        if (userType === 3) {
          console.log('🚀 ~ Company Super Admin (userType 3)');
          const isFanMode = JSON.parse(getLocalStorageItem('isB2BFansMode')) || false;
          const { errors, isValid } = EditSurveyShareDataValidation({
            email: emailInput,
            audience: surveyShareData.audience,
            endHeading: surveyShareData.endHeading,
            endBody: surveyShareData.endBody,
            isFanMode: isFanMode
          });
          console.log('🚀 ~ Validation result:', { isValid, errors });
          if (!isValid) {
            console.log('🚀 ~ Validation FAILED:', errors);
            setErrors(errors);
          } else {
            console.log('🚀 ~ Validation PASSED, sending survey...');
            setLoader(true);
            let sendDataObj = {
              id: localStorage.getItem('pulseSurveyId'),
              department: surveyShareData.audience,
              ...(emailInput && { emails: emailInput?.split(', ') }),
              ...(surveyCoverImage && { coverImage: surveyCoverImage.type }),
              ...(publishDate &&
                selectedTime && {
                  publishDateTime: convertToISO(`${publishDate} ${selectedTime}`) || ''
                }),
              // publishDateTime:
              //   publishDate && selectedTime ? convertToISO(`${publishDate} ${selectedTime}`) : '',
              endHeading: surveyShareData.endHeading?.trim(),
              endBody: surveyShareData.endBody?.trim(),
              isFanMode: JSON.parse(getLocalStorageItem('isB2BFansMode')) || false
            };
            CompanyApi.editSurveyCompany(sendDataObj)
              .then(async (response) => {
                if (response?.data?.meta?.code === 200) {
                  const meta = response.data.meta;
                  setSurveyShareData({
                    audience: '',
                    endBody: '',
                    endHeading: '',
                    shareSurveyCategory: ''
                  });
                  setEmailInput('');
                  setEmails('');
                  setSurveyCoverImage('');
                  !meta?.coverImage &&
                    !meta?.coverImage?.uploadURL &&
                    setIsShowSurveySuccessModal(true);
                  !meta?.coverImage &&
                    !meta?.coverImage?.uploadURL &&
                    successToast(pageData.surveyUpdatedSuccessMessage);
                  !meta?.coverImage && !meta?.coverImage?.uploadURL && setLoader(false);
                  if (meta?.coverImage && meta?.coverImage?.uploadURL) {
                    const uploadImageResponse = await uploadImage(
                      surveyCoverImage,
                      meta?.coverImage?.uploadURL,
                      meta?.coverImage?.filename
                    );
                    if (uploadImageResponse?.status === 200) {
                      successToast(pageData.surveyUpdatedSuccessMessage);
                      setLoader(false);
                      setIsShowSurveySuccessModal(true);
                      // setTimeout(() => {
                      //   window.location.href = '/reckit/pulse-survey';
                      //   setIsShowSurveySuccessModal(false);
                      // }, 1200);
                    } else {
                      setLoader(false);
                    }
                  }
                  // setTimeout(() => {
                  //   window.location.href = '/reckit/pulse-survey';
                  //   setIsShowSurveySuccessModal(false);
                  // }, 1200);
                } else {
                  setLoader(false);
                }
              })
              .catch((error) => {
                setLoader(false);
              });
            setErrors('');
          }
        } else {
          console.log('🚀 ~ Company Sub Admin (userType 4) - showing approval modal');
          setLoader(true);
          setIsShowSurveyApprovalModal(!isShowSurveyApprovalModal);
          CompanyApi.getAdminListCompany(3)
            .then(async (response) => {
              if (response?.data?.meta?.code === 1) {
                setLoader(false);
                setSuperAdminList(response?.data?.data);
              } else {
                setLoader(false);
              }
            })
            .catch((error) => {
              setLoader(false);
            });
        }
      } else {
        console.log('🚀 ~ ERROR: userType is not 3 or 4! userType:', userType);
      }
    }
  };

  useOutsideClick(dropdownRef, () => {
    if (isOpenQuestionType) setIsOpenQuestionType(false);
  });

  const handleSendSurveyWithApproval = () => {
    const isFanMode = JSON.parse(getLocalStorageItem('isB2BFansMode')) || false;
    const { errors, isValid } = EditSurveyShareDataValidation({
      email: emailInput,
      audience: surveyShareData.audience,
      endHeading: surveyShareData.endHeading,
      endBody: surveyShareData.endBody,
      isFanMode: userType === 3 || userType === 4 ? isFanMode : false
    });
    if (!surveyShareData?.approvalBy) {
      setErrors({ ...errors, approvalBy: pageData.approvalByRequriedMessage });
      return;
    } else {
      setIsShowSurveyApprovalModal(false);
      if (userType === 1) {
        if (!isValid && surveyType !== 'Template') {
          setErrors(errors);
          return;
        } else {
          setErrors('');
          setLoader(true);
          let sendDataObj = {
            id: localStorage.getItem('pulseSurveyId'),
            audience: surveyShareData.audience,
            ...(surveyCoverImage && { coverImage: surveyCoverImage.type }),
            ...(publishDate &&
              selectedTime && {
                publishDateTime: convertToISO(`${publishDate} ${selectedTime}`) || ''
              }),
            // publishDateTime:
            //   publishDate && selectedTime ? convertToISO(`${publishDate} ${selectedTime}`) : '',
            status: 2,
            endHeading: surveyShareData.endHeading?.trim(),
            endBody: surveyShareData.endBody?.trim(),
            approvalBy: surveyShareData.approvalBy
          };

          if (surveyType === 'Template') {
            sendDataObj = {
              id: localStorage.getItem('pulseSurveyId'),
              publishDateTime: new Date().toISOString(),
              approvalBy: surveyShareData.approvalBy
            };
          }

          surveyApi
            .editSurveyByAdmin(sendDataObj, isAdmin)
            .then(async (response) => {
              if (response?.data?.meta?.code === 200) {
                const meta = response.data.meta;
                setSurveyShareData({
                  audience: '',
                  endBody: '',
                  endHeading: '',
                  shareSurveyCategory: ''
                });
                setSurveyCoverImage('');
                !meta?.coverImage &&
                  !meta?.coverImage?.uploadURL &&
                  setIsShowSurveyApprovalModal(false);
                !meta?.coverImage &&
                  !meta?.coverImage?.uploadURL &&
                  setIsShowSurveySuccessModal(true);
                !meta?.coverImage && !meta?.coverImage?.uploadURL && setLoader(false);
                // !meta?.coverImage && !meta?.coverImage?.uploadURL && navigate('/pulse-survey');
                !meta?.coverImage &&
                  !meta?.coverImage?.uploadURL &&
                  successToast(pageData.surveyUpdatedSuccessMessage);
                if (meta?.coverImage && meta?.coverImage?.uploadURL) {
                  const uploadImageResponse = await uploadImage(
                    surveyCoverImage,
                    meta?.coverImage?.uploadURL,
                    meta?.coverImage?.filename
                  );
                  if (uploadImageResponse?.status === 200) {
                    successToast(pageData.surveyUpdatedSuccessMessage);
                    setIsShowSurveySuccessModal(true);
                    setIsShowSurveyApprovalModal(false);
                    // navigate('/pulse-survey');
                    setLoader(false);
                  }
                }
              } else {
                setLoader(false);
                setErrors('');
              }
            })
            .catch((error) => {
              setLoader(false);
            });
        }
      } else {
        if (!isValid) {
          setErrors(errors);
        } else {
          let sendDataObj = {
            id: localStorage.getItem('pulseSurveyId'),
            department: surveyShareData.audience,
            ...(emails.length > 0 && { emails: emails }),
            ...(surveyCoverImage && { coverImage: surveyCoverImage.type }),
            ...(publishDate &&
              selectedTime && {
                publishDateTime: convertToISO(`${publishDate} ${selectedTime}`) || ''
              }),
            // publishDateTime:
            //   publishDate && selectedTime ? convertToISO(`${publishDate} ${selectedTime}`) : '',
            status: 2,
            endHeading: surveyShareData.endHeading?.trim(),
            endBody: surveyShareData.endBody?.trim(),
            approvalBy: surveyShareData.approvalBy,
            isFanMode: JSON.parse(getLocalStorageItem('isB2BFansMode')) || false
          };
          setLoader(true);
          CompanyApi.editSurveyCompany(sendDataObj)
            .then(async (response) => {
              if (response?.data?.meta?.code === 200) {
                const meta = response.data.meta;
                setSurveyShareData({
                  audience: '',
                  endBody: '',
                  endHeading: '',
                  shareSurveyCategory: ''
                });
                setEmailInput('');
                setEmails('');
                setLoader(false);
                setSurveyCoverImage('');
                setIsShowSurveySuccessModal(true);
                if (meta?.coverImage && meta?.coverImage?.uploadURL) {
                  const uploadImageResponse = await uploadImage(
                    surveyCoverImage,
                    meta?.coverImage?.uploadURL,
                    meta?.coverImage?.filename
                  );
                  if (uploadImageResponse?.status === 200) {
                    successToast(pageData.imageUploadedSuccessmessage);
                    setIsShowSurveySuccessModal(true);
                    // setTimeout(() => {
                    //   window.location.href = '/reckit/pulse-survey';
                    //   setIsShowSurveySuccessModal(false);
                    // }, 1200);
                  }
                }
                // setTimeout(() => {
                //   window.location.href = '/reckit/pulse-survey';
                //   setIsShowSurveySuccessModal(false);
                // }, 1200);
              }
            })
            .catch((error) => {
              setLoader(false);
            });
          setErrors('');
        }
      }
    }
  };

  useEffect(() => {
    handleGetSurveyCategoryData();
    // surveyId && fetchData();
  }, [surveyId]);

  return (
    <>
      {loader && <Loader />}
      <div className="lg:pl-4">
        <Topbar title={title} />
      </div>
      <div className="gird font-work-sans add-survey-part">
        <div className="grid-cols-12 flex justify-between items-center sm:flex-row flex-col lg:mt-5">
          <div className="sm:col-span-6 col-span-12 flex sm:flex-row flex-wrap justify-start sm:gap-8 gap-4 lg:gap-12 sm:mt-0 w-full">
            {showPage !== 'results' && showPage !== 'insights' && (
              <>
                <Link
                  className={`text-[20px] font-medium leading-9 ${
                    showPage === 'edit' || showPage === 'preview'
                      ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                      : 'text-shoorah-gray9'
                  } ${surveyId === 'null' ? 'pointer-events-none' : 'cursor-pointer'}`}
                  disabled={surveyId === 'null' ? true : false}
                  to={getPathForSurvey(
                    `/pulse-survey/add-edit-survey?id=${surveyId}&type=${SurType}&page=edit`
                  )}
                >
                  {showPage === 'preview' ? pageData.viewBtnText : pageData.editBtnText}
                </Link>
                {surveyType !== 'Template' && contentApproval !== 1 && (
                  <Link
                    className={`text-[20px] font-medium leading-9 ${
                      showPage === 'share'
                        ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                        : 'text-shoorah-gray9'
                    } ${surveyId === 'null' ? 'pointer-events-none' : 'cursor-pointer'}`}
                    disabled={surveyId === 'null' ? true : false}
                    to={getPathForSurvey(
                      `/pulse-survey/add-edit-survey?id=${surveyId}&type=${SurType}&page=share`
                    )}
                  >
                    {pageData.shareBtnText}
                  </Link>
                )}
              </>
            )}

            {surveyId !== 'null' &&
              surveyId !== '' &&
              showPage !== 'share' &&
              showPage !== 'edit' &&
              showPage !== 'preview' &&
              surveyStatus === 5 && (
                <>
                  <div
                    className={`cursor-pointer text-[20px] font-medium leading-9 ${
                      showPage === 'results'
                        ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                        : 'text-shoorah-gray9'
                    }`}
                  >
                    <Link
                      to={getPathForSurvey(
                        `/pulse-survey/add-edit-survey?id=${surveyId}&type=${SurType}&page=results`
                      )}
                      disabled={surveyStatus !== 5}
                    >
                      {pageData.resultsBtnText}
                    </Link>
                  </div>
                  <div
                    className={`cursor-pointer text-[20px] font-medium leading-9 ${
                      showPage === 'insights'
                        ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                        : 'text-shoorah-gray9'
                    }`}
                  >
                    <Link
                      to={getPathForSurvey(
                        `/pulse-survey/add-edit-survey?id=${surveyId}&type=${SurType}&page=insights`
                      )}
                      disabled={surveyStatus !== 5}
                    >
                      {pageData.insightsBtnText}
                    </Link>
                  </div>
                </>
              )}
          </div>

          {contentApproval !== 1 && (
            <div className="sm:col-span-6 col-span-12 relative justify-end flex w-full items-center mt-3 sm:mt-0 text-[1rem]">
              {['edit', 'preview'].includes(showPage) && (
                <button
                  className="border border-shoorah-lightBlack text-shoorah-lightBlack dark:text-shoorah-darkBg dark:border-shoorah-darkBg rounded-[100px] px-4 sm:px-7 py-2 font-medium leading-[22px] truncate text-[14px]"
                  onClick={() => handlePreviewSurvey(showPage === 'edit' ? 'preview' : 'edit')}
                >
                  {showPage === 'edit' ? pageData.previewBtnText : pageData.editBtnText}{' '}
                  {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}
                </button>
              )}
            </div>
          )}
        </div>

        {showPage === 'edit' && (
          <div>
            <div className="sm:mt-9 mt-5 rounded-2xl border-[1.5px] border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder sm:p-6 p-4">
              <div
                className={`flex flex-row gap-3 justify-center bg-[#FFDC43] cursor-pointer ${
                  previewSurveyLogo
                    ? 'w-24 h-24 rounded-full p-2'
                    : 'w-full max-w-[122px] h-full px-6 py-2 rounded-3xl'
                }`}
              >
                {previewSurveyLogo ? (
                  <div className="relative inline-block w-20 h-20">
                    {/* Logo Image */}
                    <img
                      src={previewSurveyLogo}
                      alt="logo-image"
                      className="rounded-full w-full h-full border border-gray-300 object-cover"
                    />
                    <input
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      id="survey-log"
                      hidden
                      onChange={handleUploadSurveyLogo}
                    />
                    {/* Edit Icon */}
                    <button
                      type="button"
                      className="absolute top-0 right-0 bg-white dark:bg-shoorah-darkBgColor p-1 rounded-full shadow hover:shadow-md hover:bg-gray-100"
                      onClick={() => document.getElementById('survey-log').click()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 20h9" />
                        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19.001 3 20l.999-4 12.5-12.5z" />
                      </svg>
                    </button>
                  </div>
                ) : (
                  <>
                    <label
                      htmlFor="survey-log"
                      className="cursor-pointer flex items-center gap-[10px] font-medium text-[16px] leading-6 text-shoorah-lightBlack"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                          stroke="#0B1D2E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8 12H16"
                          stroke="#0B1D2E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 16V8"
                          stroke="#0B1D2E"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {pageData.logoLabel}
                    </label>
                    <input
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      id="survey-log"
                      hidden
                      onChange={handleUploadSurveyLogo}
                      disabled={surveyLogo ? true : false}
                    />
                  </>
                )}
              </div>
              <div className="sm:grid sm:grid-cols-12 text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg gap-5 mt-6 sm:w-[80%] add-survey-card">
                <div className="col-span-7">
                  <label htmlFor="title" className="font-medium text-[16px] leading-9 mb-1">
                    {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}{' '}
                    {pageData.titleLabel} <span className="text-red-400">&#42;</span>
                  </label>
                  <div className="input-field">
                    <input
                      className="w-full h-10 bg-shoorah-normanGray border-[1.5px] text-[14px] border-shoorah-borderGray rounded-[8px] px-4 flex flex-col justify-center items-start relative dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none"
                      type="text"
                      name="title"
                      id="title"
                      value={surveyData.title}
                      onChange={handleGetSurveyData}
                      placeholder={pageData.titlePlaceHolder}
                    />
                    {errors.title && <p className="text-red-500 text-sm">{errors.title}</p>}
                  </div>
                </div>
                <div className="hidden dark:block col-span-5 sm:mt-0 text-[14px] text-shoorah-lightBlack mt-4 dark:text-shoorah-darkBg">
                  <label className="font-medium text-[16px] leading-9 mb-1">
                    {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}{' '}
                    {pageData.categoryLabel} <span className="text-red-400">&#42;</span>
                  </label>
                  <div className="input-field">
                    <Select
                      options={surveyCategory}
                      name="category"
                      value={surveyCategory.find((option) => option.value === surveyData.category)}
                      onChange={handleGetSurveyCategory}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: '40px',
                          border: 'none',
                          backgroundColor: '#0F0F0F',
                          borderRadius: '0.5rem',
                          outline: 'none',
                          color: '#F1F1F1'
                        }),
                        menu: (baseStyles) => ({
                          ...baseStyles,
                          backgroundColor: '#0F0F0F',
                          borderRadius: '0.5rem'
                        }),
                        option: (baseStyles, { isFocused, isSelected }) => ({
                          ...baseStyles,
                          backgroundColor: isSelected ? '' : isFocused ? '#0F0F0F' : '#0F0F0F',
                          color: '#F1F1F1',
                          ':hover': {
                            backgroundColor: '#171717'
                          }
                        }),
                        singleValue: (baseStyles) => ({
                          ...baseStyles,
                          color: '#F1F1F1'
                        }),
                        dropdownIndicator: (baseStyles) => ({
                          ...baseStyles,
                          color: '#F1F1F1'
                        })
                      }}
                    />
                    {errors.category && <p className="text-red-500 text-sm">{errors.category}</p>}
                  </div>
                </div>
                <div className="dark:hidden block col-span-5 sm:mt-0 text-[14px] text-shoorah-lightBlack mt-4 dark:text-shoorah-darkBg">
                  <label className="font-medium text-[16px] leading-9 mb-1">
                    {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}{' '}
                    {pageData.categoryLabel} <span className="text-red-400">&#42;</span>
                  </label>
                  <div className="input-field">
                    <Select
                      options={surveyCategory}
                      name="category"
                      value={surveyCategory.find((option) => option.value === surveyData.category)}
                      onChange={handleGetSurveyCategory}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: '40px',
                          border: '1.5px solid #E7E8EA',
                          backgroundColor: '#F4F4F4',
                          borderRadius: '0.5rem',
                          color: '#0B1D2E'
                        }),
                        menu: (baseStyles) => ({
                          ...baseStyles,
                          backgroundColor: '#fff',
                          borderRadius: '0.5rem'
                        }),
                        option: (baseStyles, { isFocused, isSelected }) => ({
                          ...baseStyles,
                          backgroundColor: isSelected ? '' : isFocused ? '#EEEEEE' : '#fff',
                          color: '#0B1D2E',
                          ':hover': {
                            backgroundColor: '#EEEEEE'
                          }
                        }),
                        singleValue: (baseStyles) => ({
                          ...baseStyles,
                          color: '#0B1D2E'
                        })
                      }}
                    />
                    {errors.category && <p className="text-red-500 text-sm">{errors.category}</p>}
                  </div>
                </div>
              </div>
              <div className="text-[16px] text-shoorah-lightBlack mt-6 sm:w-[80%] dark:text-shoorah-darkBg">
                <label htmlFor="description" className="font-medium text-[16px] leading-9 mb-1">
                  {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}{' '}
                  {pageData.descriptionLabel} <span className="text-red-400">&#42;</span>
                </label>
                <div className="input-field">
                  <textarea
                    className="w-full block rounded-lg px-4 py-2 text-[14px] bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray min-h-[100px] resize-none mb-0 dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none"
                    value={surveyData.description}
                    name="description"
                    id="description"
                    placeholder={pageData.descriptionPlaceholder}
                    onChange={handleGetSurveyData}
                    maxLength={maxLength}
                  ></textarea>
                  {errors.description && (
                    <p className="text-red-500 text-sm">{errors.description}</p>
                  )}
                </div>
              </div>
            </div>
            {surveyQuestions?.length > 0 &&
              surveyQuestions?.map((surveyQuestion, index) => (
                <div
                  key={index}
                  className="px-4 py-6 sm:px-6 sm:py-8 border border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder rounded-xl mt-5"
                >
                  <div className="flex justify-center">
                    <div className="flex w-full z-0">
                      <div className="p-4 h-10 w-[60px] text-[14px] font-medium leading-9 rounded-lg mr-4 text-shoorah-lightBlack border-[1.5px] border-shoorah-borderGray bg-shoorah-normanGray flex items-center justify-center dark:bg-shoorah-darkBgColor dark:text-shoorah-darkBg dark:border-shoorah-darkBorder">
                        {pageData.questionSign}
                        {index + 1}
                      </div>
                      <div className="question-title flex flex-col">
                        <h2 className="tracking-none sm:tracking-normal h-fit w-auto font-medium leading-9 text-[18.5px] sm:text-[24px] mb-6 text-shoorah-lightBlack dark:text-shoorah-darkBg">
                          {surveyQuestion?.questionTitle}
                        </h2>
                        {surveyQuestion.image && (
                          <img
                            src={
                              isUrl(surveyQuestion.image)
                                ? surveyQuestion.image
                                : getFilePreviewUrl(surveyQuestion.image)
                            }
                            alt="preview-image"
                            className="w-[400px] h-[200px] object-cover mb-6"
                            onError={(e) => {
                              e.target.style.display = 'none'; // Hide image if loading fails
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="relative inline-block">
                      <div
                        className="dropdown-toggle justify-end text-shoorah-lightBlack text-[16px] flex items-center rounded-xl cursor-pointer"
                        onClick={() => toggleDropdown(index)}
                      >
                        <img src={Dots} alt="Dots icon" className="w-6 h-6 block dark:hidden" />
                        <img
                          src={ActiveDots}
                          alt="Dots icon"
                          className="w-6 h-6 hidden dark:block"
                        />
                        {isOpen && index === dropDownIndex && (
                          <div
                            className="w-40 top-[13px] left-[-131px] z-50 bg-[#FFFFFF] absolute mt-2 border-[1.5px] py-[14px] border-[#DDDDDD] rounded-lg"
                            style={{
                              zIndex: 274
                            }}
                          >
                            <div
                              onClick={() => [
                                setIsOpen(!isOpen),
                                handleQuestionAction('edit', index, surveyQuestion)
                              ]}
                              className="py-1 text-left px-5 hover:bg-[#E7E8EA] cursor-pointer font-medium leading-6 text-[16px]"
                            >
                              {pageData.editBtnText}
                            </div>
                            <div
                              onClick={() => [
                                setIsOpen(!isOpen),
                                handleQuestionAction('duplicate', index, surveyQuestion)
                              ]}
                              className="py-1 text-left px-5 hover:bg-[#E7E8EA] cursor-pointer font-medium leading-6 text-[16px]"
                            >
                              {pageData.duplicateBtnText}
                            </div>
                            <div className="border-b border-gray-400 w-full my-2"></div>
                            <div
                              onClick={() => [
                                setIsOpen(!isOpen),
                                handleQuestionAction('delete', index, surveyQuestion)
                              ]}
                              className="py-1 text-left px-5 hover:bg-[#E7E8EA] cursor-pointer text-red-700 font-medium leading-6 text-[16px]"
                            >
                              {pageData.deleteBtnText}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {surveyQuestion?.options?.filter((opt) => opt?.value !== '')?.length > 0 && (
                    <div className="w-full flex flex-col items-center">
                      <div className="flex flex-col space-y-4 w-[90%] justify-center">
                        {surveyQuestion?.options
                          ?.filter((opt) => opt?.value !== '')
                          ?.map((opt, index) => (
                            <label className="flex items-center" key={index}>
                              <input
                                type="radio"
                                name="answerRadio"
                                className="w-5 h-5 rounded-answer-choice"
                                disabled
                              />
                              <p className="ml-4 w-[calc(100%-20px)] text-shoorah-lightBlack font-medium dark:text-shoorah-darkBg">
                                {' '}
                                {opt?.value}
                              </p>
                            </label>
                          ))}
                      </div>
                    </div>
                  )}
                  {surveyQuestion?.qType === 3 && (
                    <div className="relative w-[calc(100%-56px)] ml-14">
                      <div className="md:w-[89%] lg:w-[80%] relative">
                        <div className="absolute left-4 top-7">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className="opacity-50 stroke-shoorah-lightBlack dark:stroke-gray-400"
                          >
                            <g opacity="0.5" clip-path="url(#clip0_302_19223)">
                              <path
                                d="M16.4384 7.76362C16.4027 6.95987 16.3344 6.16644 16.2547 5.38522C16.0529 3.40836 14.456 1.81088 12.4801 1.60011C11.3187 1.47622 10.1303 1.37729 8.92123 1.37729C7.71212 1.37729 6.52378 1.47622 5.36234 1.60011C3.38644 1.81088 1.78957 3.40836 1.58781 5.38522C1.47002 6.53927 1.37732 7.71996 1.37732 8.9212C1.37732 10.1224 1.47002 11.3031 1.58781 12.4572C1.78957 14.4341 3.38656 16.0315 5.36247 16.2423C6.32421 16.3449 7.3044 16.4303 8.29954 16.4567"
                                stroke-width="1.428"
                                stroke-linecap="round"
                              />
                              <path
                                d="M5.20227 6.73435V6.18918C5.20227 5.54864 5.65954 4.99484 6.29462 4.91143C8.05762 4.67983 9.77632 4.67983 11.5393 4.91143C12.1744 4.99484 12.6317 5.54864 12.6317 6.18918V6.73435"
                                stroke-width="1.428"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8.91711 4.73773V11.2177"
                                stroke-width="1.428"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M15.4455 11.1897L11.6435 15.5036L11.1227 17.9533C11.0389 18.3475 11.4498 18.7204 11.8345 18.5995L14.2724 17.8331L18.1993 13.701C18.8516 13.0147 18.7378 11.8669 17.9482 11.1686C17.1773 10.4866 16.0568 10.4961 15.4455 11.1897Z"
                                stroke-width="1.428"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_302_19223">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <textarea
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          maxLength={maxLength}
                          readOnly
                          placeholder="Enter Multiple Choice Question"
                          className="w-full h-[120px] rounded-xl p-3 pt-[10px] pl-[40px] bg-shoorah-normanGray dark:border-shoorah-darkBorder dark:bg-shoorah-darkBgColor focus:outline-none mt-4 border-[1.5px] border-shoorah-borderGray resize-none"
                        />
                        <span className="absolute bottom-5 right-5 text-gray-400 text-sm">
                          *{maxLength} {pageData.characterLimitText}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            <div className="mt-5 rounded-2xl border-[1.5px] border-shoorah-borderGray sm:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder sm:mb-10">
              <div className="block w-full h-full">
                <h3 className="text-[20px] leading-9 font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
                  {pageData.addQuestionLabel}
                </h3>
                <div className="sm:grid sm:grid-cols-12 gap-4 mt-4 items-start w-full">
                  <div className="col-span-1 xl:col-span-7 sm:col-span-6">
                    <div className="input-field">
                      <input
                        className="mb-5 sm:mb-0 w-full h-10 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:text-shoorah-darkBg focus:outline-none dark:border-shoorah-darkBorder border-[1.5px] text-[14px] font-medium border-shoorah-borderGray rounded-[8px] px-4 flex flex-col justify-center items-start relative"
                        type="text"
                        placeholder={pageData.addQuestionPlaceholder}
                        name="questionTitle"
                        autoComplete="off"
                        value={surveyQuestionData.questionTitle}
                        onChange={handleGetQuestionData}
                      />
                    </div>
                  </div>
                  <div className="xl:col-span-5 sm:col-span-6 col-span-1 flex gap-5 items-start">
                    <div className={`w-10 h-10 relative`}>
                      {surveyQuestionData.image ? (
                        <div className="relative group">
                          <img
                            src={
                              surveyQuestionData.image instanceof File
                                ? getFilePreviewUrl(surveyQuestionData.image)
                                : surveyQuestionData.image
                            }
                            alt="question-image"
                            className="w-10 h-10 object-cover rounded-lg cursor-pointer "
                            style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}
                          />
                          <label
                            htmlFor="question-image"
                            className="absolute cursor-pointer top-0 left-0 w-10 h-10 rounded-lg bg-black opacity-0 group-hover:opacity-50 flex items-center justify-center duration-100 transition-all ease-in-out"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M12 20h9" />
                              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19.001 3 20l.999-4 12.5-12.5z" />
                            </svg>
                          </label>
                        </div>
                      ) : (
                        <>
                          <label
                            htmlFor="question-image"
                            className="cursor-pointer mb-5 sm:mb-0 flex items-center justify-center bg-shoorah-normanGray w-30 h-30 rounded-lg dark:bg-shoorah-darkBgColor"
                            style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}
                          >
                            <svg
                              width="40"
                              height="40"
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="dark:fill-shoorah-darkBg"
                            >
                              <rect
                                x="0.75"
                                y="0.75"
                                width="38.5"
                                height="38.5"
                                rx="7.25"
                                fill="#F4F4F4"
                                stroke="#E7E8EA"
                                strokeWidth="1.5"
                                className="fill-shoorah-normanGray dark:fill-shoorah-darkBgColor stroke-shoorah-borderGray dark:stroke-shoorah-darkBgColor"
                              />
                              <path
                                d="M17 30H23C28 30 30 28 30 23V17C30 12 28 10 23 10H17C12 10 10 12 10 17V23C10 28 12 30 17 30Z"
                                stroke="#0B1D2E"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M17 18C18.1046 18 19 17.1046 19 16C19 14.8954 18.1046 14 17 14C15.8954 14 15 14.8954 15 16C15 17.1046 15.8954 18 17 18Z"
                                stroke="#0B1D2E"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10.6699 26.9496L15.5999 23.6396C16.3899 23.1096 17.5299 23.1696 18.2399 23.7796L18.5699 24.0696C19.3499 24.7396 20.6099 24.7396 21.3899 24.0696L25.5499 20.4996C26.3299 19.8296 27.5899 19.8296 28.3699 20.4996L29.9999 21.8996"
                                stroke="#0B1D2E"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </label>
                        </>
                      )}
                      <input
                        type="file"
                        id="question-image"
                        hidden
                        accept=".jpg, .jpeg, .png"
                        onChange={handleUploadQuestionImage}
                        // disabled={!!tempImagePreview}
                      />
                    </div>
                    <div
                      ref={dropdownRef}
                      className="whitespace-nowrap relative inline-block w-full sm:w-[200px]"
                    >
                      <div
                        className="dropdown-toggle border w-full sm:max-w-[200px] bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder dark:text-shoorah-darkBg text-shoorah-lightBlack text-[16px] border-shoorah-borderGray flex items-center h-10 rounded-[8px] cursor-pointer justify-between px-4"
                        onClick={() => setIsOpenQuestionType(!isOpenQuestionType)}
                      >
                        <span className="text-shoorah-lightBlack dark:text-shoorah-darkBg text-[12px]">
                          {surveyQuestionData.qType === 1
                            ? pageData.selectTypeOption.singleChoice
                            : surveyQuestionData.qType === 2
                            ? pageData.selectTypeOption.multipleChoice
                            : surveyQuestionData.qType === 3
                            ? 'Input'
                            : pageData.selectTypeOption.default}
                        </span>
                        <svg
                          className={`w-4 h-4 transform ${isOpenQuestionType ? 'rotate-180' : ''}`}
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                      {isOpenQuestionType && (
                        <div className="whitespace-nowrap absolute top-full z-40 right-0 w-full bg-white dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray rounded-xl mt-2 py-3">
                          {/* <div
                            className="dropdown-item p-2 hover:bg-[#E7E8EA] dark:hover:bg-shoorah-darkBgTabColor cursor-pointer text-[14px] leading-6"
                            onClick={() => [
                              setSurveyQuestionData({ ...surveyQuestionData, qType: '' }),
                              setIsOpenQuestionType(!isOpenQuestionType)
                            ]}
                          >
                            Select Type
                          </div> */}
                          <div
                            className="dropdown-item p-2 hover:bg-[#E7E8EA] dark:hover:bg-shoorah-darkBgTabColor cursor-pointer text-[14px] leading-6"
                            onClick={() => [
                              setSurveyQuestionData({ ...surveyQuestionData, qType: 1 }),
                              setIsOpenQuestionType(!isOpenQuestionType)
                            ]}
                          >
                            {pageData.selectTypeOption.singleChoice}
                          </div>
                          <div
                            className="dropdown-item p-2 hover:bg-[#E7E8EA] dark:hover:bg-shoorah-darkBgTabColor cursor-pointer text-[14px] leading-6"
                            onClick={() => [
                              setSurveyQuestionData({ ...surveyQuestionData, qType: 2 }),
                              setIsOpenQuestionType(!isOpenQuestionType)
                            ]}
                          >
                            {pageData.selectTypeOption.multipleChoice}
                          </div>
                          <div
                            className="dropdown-item p-2 hover:bg-[#E7E8EA] dark:hover:bg-shoorah-darkBgTabColor cursor-pointer text-[14px] leading-6"
                            onClick={() => [
                              setSurveyQuestionData({ ...surveyQuestionData, qType: 3 }),
                              setIsOpenQuestionType(!isOpenQuestionType)
                            ]}
                          >
                            {pageData.selectTypeOption.inputFieldText}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {(surveyQuestionData.qType === 1 || surveyQuestionData.qType === 2) && (
                <>
                  <div className="w-full sm:w-[59%] flex justify-between">
                    <label className="block text-[16px] leading-9 font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg sm:mt-[45px] mt-6 mb-[10px]">
                      {pageData.answerChoicesLabel}
                    </label>
                  </div>
                  <div className="grid grid-cols-12 sm:gap-4 sm:w-[80%] w-full mb-6">
                    {answerChoices?.map((choice, index) => (
                      <div key={index} className="col-span-12 sm:col-span-10 mb-3 sm:mb-0">
                        <div className="flex items-center justify-between gap-5">
                          <div className="input-field w-full">
                            <input
                              className="w-full h-10 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:text-shoorah-darkBg dark:border-shoorah-darkBorder focus:outline-none border-[1.5px] text-[14px] border-shoorah-borderGray rounded-[8px] px-4 flex flex-col justify-center items-start relative"
                              type="text"
                              placeholder={pageData.answerChoicesPlaceholder}
                              name="options"
                              autoComplete="off"
                              value={choice.value || ''}
                              onChange={(e) => handleGetQueAns(index, e)}
                              readOnly={
                                surveyQuestionData.hasOther === choice.value ||
                                surveyQuestionData.nonAbove === choice.value
                                  ? true
                                  : false
                              }
                            />
                          </div>
                          <div className="flex gap-[10px]">
                            <button
                              className="flex justify-center items-center"
                              onClick={addAnswerField}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                                  stroke="#A1A1A1"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M8 12H16"
                                  stroke="#A1A1A1"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M12 16V8"
                                  stroke="#A1A1A1"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            <button
                              className="flex justify-center items-center"
                              onClick={() => {
                                // if (surveyQuestionCount > 1) {
                                removeAnswerField(index);
                                // }
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.92 22C17.42 22 21.92 17.5 21.92 12C21.92 6.5 17.42 2 11.92 2C6.41998 2 1.91998 6.5 1.91998 12C1.91998 17.5 6.41998 22 11.92 22Z"
                                  stroke="#A1A1A1"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M7.91998 12H15.92"
                                  stroke="#A1A1A1"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="flex sm:justify-start rounded-xl flex-col justify-start mb-10">
                    <button
                      className="flex gap-2 justify-center items-center rounded-[25px] border border-[#A1A1A1] dark:border-shoorah-darkBg px-6 py-[7px] w-fit"
                      onClick={() => {
                        setIsBulkModalOpen(true);
                      }}
                    >
                      <svg
                        width="21"
                        height="20"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="dark:fill-shoorah-darkBg"
                      >
                        <path
                          d="M8.50004 14.6666C12.1667 14.6666 15.1667 11.6666 15.1667 7.99998C15.1667 4.33331 12.1667 1.33331 8.50004 1.33331C4.83337 1.33331 1.83337 4.33331 1.83337 7.99998C1.83337 11.6666 4.83337 14.6666 8.50004 14.6666Z"
                          stroke="#0B1D2E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M5.83337 8H11.1667"
                          stroke="#0B1D2E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8.5 10.6666V5.33331"
                          stroke="#0B1D2E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <p className="text-[14px] text-shoorah-lightBlack dark:text-shoorah-darkBg font-medium leading-6">
                        {pageData.bulkAnswersBtnText}
                      </p>
                    </button>
                  </div>
                </>
              )}

              {surveyQuestionData.qType !== '' && surveyQuestionData.qType !== 3 && (
                <>
                  <label className="block text-[16px] leading-9 font-medium text-shoorah-lightBlack mt-5 dark:text-shoorah-darkBg">
                    {pageData.answerChoicesLabel}
                  </label>
                  <div className="w-full">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
                      <div className="flex items-center sm:px-3 px-2 py-2 border border-[#CED2D5] rounded-[25px] dark:border-shoorah-darkBg">
                        <input
                          id="other-ans-choice-1"
                          type="checkbox"
                          className="rounded-answer-choice"
                          checked={surveyQuestionData.hasOther}
                          value={surveyQuestionData.hasOther}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setSurveyQuestionData((prevData) => ({
                              ...prevData,
                              hasOther: isChecked
                            }));
                            setAnswerChoices((prevChoices) =>
                              isChecked
                                ? [...prevChoices, { value: 'Other' }]
                                : prevChoices.filter((choice) => choice.value !== 'Other')
                            );
                          }}
                        />
                        <label
                          htmlFor="other-ans-choice-1"
                          className="ml-3 text-sm font-medium leading-6 text-gray-900 dark:text-shoorah-darkBg"
                        >
                          {pageData.addOtherAnswerChoicesText}
                        </label>
                      </div>

                      <div className="flex items-center sm:px-3 px-2 py-2 border border-[#CED2D5] rounded-[25px] dark:border-shoorah-darkBg">
                        <input
                          id="other-ans-choice-2"
                          type="checkbox"
                          className="rounded-answer-choice"
                          checked={surveyQuestionData.skipable}
                          onChange={(e) => {
                            setSurveyQuestionData((prevData) => ({
                              ...prevData,
                              skipable: !prevData.skipable
                            }));
                          }}
                        />
                        <label
                          htmlFor="other-ans-choice-2"
                          className="ml-3 text-sm font-medium leading-6 text-gray-900 dark:text-shoorah-darkBg"
                        >
                          {pageData.skipableQuestionLabel}
                        </label>
                      </div>

                      <div className="flex items-center sm:px-3 px-2 py-2 border border-[#CED2D5] rounded-[25px] dark:border-shoorah-darkBg">
                        <input
                          id="other-ans-choice-3"
                          type="checkbox"
                          className="rounded-answer-choice"
                          checked={surveyQuestionData.nonAbove}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setSurveyQuestionData((prevData) => ({
                              ...prevData,
                              nonAbove: isChecked
                            }));
                            setAnswerChoices((prevChoices) =>
                              isChecked
                                ? [...prevChoices, { value: 'None of the above' }]
                                : prevChoices.filter(
                                    (choice) => choice.value !== 'None of the above'
                                  )
                            );
                          }}
                        />
                        <label
                          htmlFor="other-ans-choice-3"
                          className="ml-3 text-sm font-medium leading-6 text-gray-900 dark:text-shoorah-darkBg"
                        >
                          {pageData.noneOfTheAboveOptionLabel}
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <p className="text-red-500 text-sm mt-2">{errors?.questions && errors?.questions}</p>

              <div className="mt-10 flex justify-end">
                <button
                  className="btn-primary"
                  onClick={handleSaveSurveyQuestion}
                >
                  {pageData.saveQuestionBtnText}
                </button>
              </div>
            </div>
          </div>
        )}

        {showPage === 'share' && (
          <SurveyShare
            handleEmailChange={handleEmailChange}
            openTeamDropDown={() => setIsOpenShareSurveyTeamMenu((prev) => !prev)}
            surveyShareData={surveyShareData}
            isOpenShareSurveyTeamMenu={isOpenShareSurveyTeamMenu}
            userType={userType}
            setIsOpenShareSurveyTeamMenu={setIsOpenShareSurveyTeamMenu}
            setAudienceType={(value) =>
              setSurveyShareData({
                ...surveyShareData,
                audience: value
              })
            }
            errors={errors}
            surveyCategory={surveyCategory}
            handleGetSurveyCategory={(e) => handleGetSurveyCategory(e)}
            emailInput={emailInput}
            coverImg={coverImg}
            handleCoverImage={(e) => {
              const file = e.target.files[0];
              if (!file?.name?.match(/\.(jpg|jpeg|png)$/i)) {
                errorToast(pageData.imageFormatNotSupportedMessage);
              } else {
                setSurveyCoverImage(file);
                setCoverImgUrl(URL.createObjectURL(file));
              }
            }}
            handleToggleCalendar={handleToggleCalendar}
            publishDate={publishDate}
            showCalendar={showCalendar}
            handleChangeC={(e) => handleChangeC(e)}
            handleTimeToggle={() => setIsOpenT(!isOpenT)}
            selectedTime={selectedTime}
            isOpenT={isOpenT}
            handleSelectT={(time) => handleSelectT(time)}
            handleGetEndPageData={(e) => handleGetEndPageData(e)}
            handleSendSurvey={() => handleSendSurvey()}
            addUserPopUpOpenSurvey={addUserPopUpOpenSurvey}
            handleUserPopUpOenSurvey={() => setAddUserPopUpOpenSurvey(!addUserPopUpOpenSurvey)}
            shareSurveyTeamOptions={shareSurveyTeamOptions}
            setSurveyShareData={setSurveyShareData}
            handleShareSurveyTeamOptions={(e, data) => {
              setIsOpenShareSurveyTeamMenu(true);

              const currentAudience = surveyShareData.audience || [];

              const updatedAudience = currentAudience.includes(e.target.value)
                ? currentAudience.filter((item) => item !== e.target.value)
                : [...currentAudience, e.target.value];

              setSurveyShareData({
                ...surveyShareData,
                audience: updatedAudience,
                selectedLabel: data
              });
            }}
          />
        )}

        {showPage === 'preview' && (
          <div className="lg:mb-12">
            <div className="sm:mt-9 mt-5 rounded-2xl border-[1.5px] border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder sm:p-6 p-4">
              <div
                className={`flex flex-row gap-3 justify-center bg-[#FFDC43] ${
                  previewSurveyLogo
                    ? 'w-20 h-20 rounded-full p-2'
                    : 'w-full max-w-[122px] h-full px-6 py-2 rounded-3xl'
                }`}
              >
                {previewSurveyLogo ? (
                  <img
                    src={previewSurveyLogo}
                    alt="logo-image"
                    className="rounded-full w-full h-full"
                  />
                ) : (
                  <label className="flex items-center gap-[10px] text-shoorah-lightBlack font-medium text-[16px] leading-6">
                    {pageData.logoLabel}
                  </label>
                )}
              </div>
              <div className="sm:grid sm:grid-cols-12 text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg gap-5 mt-6 sm:w-[80%] add-survey-card">
                <div className="col-span-7">
                  <label htmlFor="title" className="font-medium text-[16px] leading-9 mb-1">
                    {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}{' '}
                    {pageData.titleLabel}
                  </label>
                  <div className="input-field">
                    <input
                      className="w-full h-10 bg-shoorah-normanGray border-[1.5px] text-[14px] border-shoorah-borderGray rounded-[8px] px-4 flex flex-col justify-center items-start relative dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none"
                      type="text"
                      name="title"
                      readOnly
                      id="title"
                      value={surveyData?.title || ''}
                    />
                  </div>
                </div>
                <div className="col-span-5 sm:mt-0 text-[14px] text-shoorah-lightBlack mt-4 dark:text-shoorah-darkBg dark:border-shoorah-darkBorder">
                  <label className="font-medium text-[16px] leading-9 mb-1">
                    {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}{' '}
                    {pageData.categoryLabel}
                  </label>
                  <div className="input-field dark:block hidden">
                    <Select
                      options={surveyCategory}
                      name="category"
                      value={surveyCategory.find((option) => option.value === surveyData.category)}
                      onChange={handleGetSurveyCategory}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: '40px',
                          border: 'none',
                          backgroundColor: '#0F0F0F',
                          borderRadius: '0.5rem',
                          outline: 'none',
                          pointerEvents: 'none',
                          color: '#F1F1F1'
                        }),
                        menu: (baseStyles) => ({
                          ...baseStyles,
                          backgroundColor: '#0F0F0F',
                          borderRadius: '0.5rem'
                        }),
                        option: (baseStyles, { isFocused, isSelected }) => ({
                          ...baseStyles,
                          backgroundColor: isSelected ? '' : isFocused ? '#0F0F0F' : '#0F0F0F',
                          color: '#F1F1F1',
                          ':hover': {
                            backgroundColor: '#171717'
                          }
                        }),
                        singleValue: (baseStyles) => ({
                          ...baseStyles,
                          color: '#F1F1F1'
                        }),
                        dropdownIndicator: (baseStyles) => ({
                          ...baseStyles,
                          color: '#F1F1F1'
                        })
                      }}
                    />
                  </div>
                  <div className="input-field dark:hidden block">
                    <Select
                      options={surveyCategory}
                      name="category"
                      isDisabled={true}
                      value={surveyCategory.find((option) => option.value === surveyData.category)}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: '40px',
                          border: '1.5px solid #E7E8EA',
                          backgroundColor: '#F4F4F4',
                          borderRadius: '0.5rem',
                          color: '#0B1D2E'
                        }),
                        menu: (baseStyles) => ({
                          ...baseStyles,
                          backgroundColor: '#fff',
                          borderRadius: '0.5rem'
                        }),
                        option: (baseStyles, { isFocused, isSelected }) => ({
                          ...baseStyles,
                          backgroundColor: isSelected ? '' : isFocused ? '#EEEEEE' : '#fff',
                          color: '#0B1D2E',
                          ':hover': {
                            backgroundColor: '#EEEEEE'
                          }
                        }),
                        singleValue: (baseStyles) => ({
                          ...baseStyles,
                          color: '#0B1D2E'
                        })
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="text-[16px] text-shoorah-lightBlack mt-6 sm:w-[80%] dark:text-shoorah-darkBg">
                <label htmlFor="description" className="font-medium text-[16px] leading-9 mb-1">
                  {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}{' '}
                  {pageData.descriptionLabel}
                </label>
                <div className="input-field">
                  <textarea
                    className="w-full block rounded-lg px-4 py-2 text-[14px] bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray min-h-[100px] resize-none mb-0 dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none"
                    value={surveyData?.description || ''}
                    name="description"
                    id="description"
                    readOnly
                  ></textarea>
                </div>
              </div>
            </div>
            {surveyQuestions?.length > 0 &&
              surveyQuestions?.map((surveyQuestion, index) => (
                <div
                  key={index}
                  className="px-4 py-4 sm:px-6 sm:py-8 border border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder rounded-xl mt-5"
                >
                  <div className="flex justify-center">
                    <div className="flex w-full z-0">
                      <div className="p-4 h-10 w-[60px] text-[14px] font-medium leading-9 rounded-lg mr-4 text-shoorah-lightBlack border-[1.5px] border-shoorah-borderGray bg-shoorah-normanGray flex items-center justify-center dark:bg-shoorah-darkBgColor dark:text-shoorah-darkBg dark:border-shoorah-darkBorder">
                        {pageData.questionSign}
                        {index + 1}
                      </div>
                      <div className="question-title flex flex-col">
                        <h2 className="tracking-none sm:tracking-normal h-fit w-auto font-medium leading-9 text-[18.5px] sm:text-[24px] mb-6 text-shoorah-lightBlack dark:text-shoorah-darkBg">
                          {surveyQuestion?.questionTitle}
                        </h2>
                        {surveyQuestion.image && (
                          <img
                            src={
                              isUrl(surveyQuestion.image)
                                ? surveyQuestion.image
                                : getFilePreviewUrl(surveyQuestion.image)
                            }
                            alt="preview-image"
                            className="w-[400px] h-[200px] object-cover mb-6"
                            onError={(e) => {
                              e.target.style.display = 'none'; // Hide image if loading fails
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {surveyQuestion?.options?.filter((opt) => opt?.value !== '')?.length > 0 && (
                    <div className="w-full flex flex-col items-center">
                      <div className="flex flex-col space-y-4 w-[90%] justify-center">
                        {surveyQuestion?.options
                          ?.filter((opt) => opt?.value !== '')
                          ?.map((opt, index) => (
                            <label className="flex items-center" key={index}>
                              <input
                                type="radio"
                                name="answerRadio"
                                className="w-5 h-5 rounded-answer-choice"
                                disabled
                              />
                              <p className="ml-4 w-[calc(100%-20px)] text-shoorah-lightBlack font-medium dark:text-shoorah-darkBg">
                                {' '}
                                {opt?.value}
                              </p>
                            </label>
                          ))}
                      </div>
                    </div>
                  )}
                  {surveyQuestion?.qType === 3 && (
                    <div className="relative w-[calc(100%-56px)] ml-14">
                      <div className="relative w-full h-[120px] md:w-[89%] lg:w-[80%]">
                        <textarea
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          maxLength={maxLength}
                          readOnly
                          placeholder="Enter Multiple Choice Question"
                          className="w-full h-[120px] rounded-xl p-3 pt-[10px] pl-[40px] bg-shoorah-normanGray dark:border-shoorah-darkBorder dark:bg-shoorah-darkBgColor focus:outline-none mt-4 border-[1.5px] border-shoorah-borderGray resize-none"
                        />
                        <div className="absolute left-4 top-7">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="opacity-50 fill-shoorah-lightBlack dark:fill-shoorah-darkBg"
                          >
                            <g clipPath="url(#clip0_302_19223)">
                              <path
                                d="M16.4384 7.76362C16.4027 6.95987 16.3344 6.16644 16.2547 5.38522C16.0529 3.40836 14.456 1.81088 12.4801 1.60011C11.3187 1.47622 10.1303 1.37729 8.92123 1.37729C7.71212 1.37729 6.52378 1.47622 5.36234 1.60011C3.38644 1.81088 1.78957 3.40836 1.58781 5.38522C1.47002 6.53927 1.37732 7.71996 1.37732 8.9212C1.37732 10.1224 1.47002 11.3031 1.58781 12.4572C1.78957 14.4341 3.38656 16.0315 5.36247 16.2423C6.32421 16.3449 7.3044 16.4303 8.29954 16.4567"
                                stroke="#0B1D2E"
                                strokeWidth="1.428"
                                strokeLinecap="round"
                              />
                              <path
                                d="M5.20227 6.73435V6.18918C5.20227 5.54864 5.65954 4.99484 6.29462 4.91143C8.05762 4.67983 9.77632 4.67983 11.5393 4.91143C12.1744 4.99484 12.6317 5.54864 12.6317 6.18918V6.73435"
                                stroke="#0B1D2E"
                                strokeWidth="1.428"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8.91711 4.73773V11.2177"
                                stroke="#0B1D2E"
                                strokeWidth="1.428"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M15.4455 11.1897L11.6435 15.5036L11.1227 17.9533C11.0389 18.3475 11.4498 18.7204 11.8345 18.5995L14.2724 17.8331L18.1993 13.701C18.8516 13.0147 18.7378 11.8669 17.9482 11.1686C17.1773 10.4866 16.0568 10.4961 15.4455 11.1897Z"
                                stroke="#0B1D2E"
                                strokeWidth="1.428"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_302_19223">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <span className="absolute -bottom-1 right-5 text-gray-400 text-sm">
                          *{maxLength} {pageData.characterLimitText}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            {contentApproval != 1 && (
              <div className="w-full">
                <div className="flex flex-wrap mt-[20px] gap-2 sm:gap-5">
                  <div className="col-span-12 sm:col-span-6">
                    <button
                      className="btn-primary"
                      onClick={handleSubmitSurvey}
                    >
                      {pageData.submitBtnText}{' '}
                      {surveyType === 'Survey' ? pageData.surveyLabel : pageData.templateLabel}
                      <div className="sm:hidden lg:flex">
                        <svg
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.44006 13.2801L10.7867 8.9334C11.3001 8.42006 11.3001 7.58006 10.7867 7.06673L6.44006 2.72006"
                            stroke="white"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </button>
                  </div>
                  <div className="lg:w-[160px] md:col-span-6">
                    <button
                      className="whitespace-nowrap p-4 w-full text-shoorah-lightBlack dark:text-shoorah-darkBg dark:border-shoorah-darkBg border border-shoorah-lightBlack py-[7px] rounded-full"
                      onClick={handleSaveDraft}
                    >
                      {pageData.saveAsDraftBtnText}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {
          showPage === 'insights' && (
            // (isCopanySuperOrSubAdmin() ? (
            //   <InsightsB2B InsightsData={insightsData} userAgeRangeData={userAgeRangeData} />
            // ) : (
            <InsightsSuper InsightsData={insightsData} userAgeRangeData={userAgeRangeData} />
          )
          // ))
        }

        {showPage === 'results' && (
          <>
            {!loader && surveyQuestionResultList?.length > 0 ? (
              surveyQuestionResultList?.map((data, index) => (
                <AssessmentResultQuestion questionsList={data} index={index} key={index} />
              ))
            ) : (
              <div className="px-3 py-6 sm:px-7 sm:py-10 border mt-[25px] border-[#E7E8EA] text-[20px] bg-white font-medium rounded-2xl dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder flex items-center justify-center">
                {pageData.noDataFoundText}
              </div>
            )}
          </>
        )}

        {isBulkModalOpen && (
          <BulkAnswerModal
            bulkAnswerInput={bulkAnswerInput}
            handleGetBulkAnswerData={(e) => handleGetBulkAnswerData(e)}
            maxLength={maxLength}
            handleSaveBulkAnswer={(type) => handleSaveBulkAnswer(type)}
          />
        )}

        {isShowSurveyApprovalModal && (
          <SurveyApprovalModal
            adminList={superAdminList}
            error={errors.approvalBy}
            handleChange={(e) => {
              setSurveyShareData({ ...surveyShareData, approvalBy: e.value });
              setErrors({ ...errors, approvalBy: '' });
            }}
            handleSendSurveyWithApproval={() => handleSendSurveyWithApproval()}
          />
        )}
        {isShowSurveySuccessModal && (
          <SurveySuccessModal isDraft={isDraft} surveyType={surveyType} />
        )}
      </div>
    </>
  );
};
export default AddEditPulseSurvey;
